import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../abstraction/auth.service';

enum ONBOARDING_FLOW {
  WORLDCOIN,
  WIDGET,
}

enum FLOW_ONBOARDING {
  'auth' = ONBOARDING_FLOW.WORLDCOIN,
  'onboarding' = ONBOARDING_FLOW.WIDGET,
}

export const setIsNewFlow: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const flow = FLOW_ONBOARDING[route.routeConfig.path];
  if (flow === ONBOARDING_FLOW.WORLDCOIN) {
    if (auth.getWidgetUserFromLS()) {
      auth.logoutWidgetUser();
    }
    auth.setNewFlowOnboarding(false);
  }
  if (flow === ONBOARDING_FLOW.WIDGET) {
    if (auth.getUserFromLS()) {
      auth.logoutWLD();
    }
    auth.setNewFlowOnboarding(true);
  }
  return true;
};
